import { render, staticRenderFns } from "./publicacoes.vue?vue&type=template&id=19894e48"
import script from "./publicacoes.vue?vue&type=script&lang=js"
export * from "./publicacoes.vue?vue&type=script&lang=js"
import style0 from "./publicacoes.vue?vue&type=style&index=0&id=19894e48&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports